exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__card-overlay___rm-ic{position:absolute;width:100%;height:100%;overflow:hidden;border-radius:.25rem}.styles__card-overlay___rm-ic .styles__overlay___ly8we{position:absolute;width:100%;height:100%;background-repeat:no-repeat;background-position:50%;background-size:cover;filter:blur(20px) brightness(.75);backface-visibility:hidden;perspective:1000;transform:translateZ(0);will-change:transform}", ""]);

// exports
exports.locals = {
	"card-overlay": "styles__card-overlay___rm-ic",
	"overlay": "styles__overlay___ly8we"
};